export const promotionBasicLanguage = {
    en: {
        ActiveThisRule: 'Active this rule',
        Name: 'Name',
        Code: 'Code',
        AlternateName1: 'Alternate Name1',
        AlternateName2: 'Alternate Name2',
        Rate: 'Rate',
        TaxRate: 'Tax Rate',
        Member: 'Member',
        MemberOnly: 'Member Only',
        NonMember: 'Non Member',
        Everyone: 'Everyone',
    },
    th: {
        ActiveThisRule: 'เปิดใช้งานกฎนี้',
        Name: 'ชื่อ',
        Code: 'รหัส',
        AlternateName1: 'ชื่อทางเลือก 1',
        AlternateName2: 'ชื่อทางเลือก 2',
        Rate: 'อัตรา',
        TaxRate: 'อัตราภาษี',
        Member: 'สมาชิก',
        MemberOnly: 'เฉพาะสมาชิก',
        NonMember: 'ไม่ใช่สมาชิก',
        Everyone: 'ทุกคน',
    },
    cn: {
        ActiveThisRule: '启用此规则',
        Name: '名称',
        Code: '代码',
        AlternateName1: '备用名称1',
        AlternateName2: '备用名称2',
        Rate: '税率',
        TaxRate: '税率',
        Member: '会员',
        MemberOnly: '仅会员',
        NonMember: '非会员',
        Everyone: '所有人',
    },
    jp: {
        ActiveThisRule: 'このルールを有効にする',
        Name: '名前',
        Code: 'コード',
        AlternateName1: '代替名1',
        AlternateName2: '代替名2',
        Rate: '税率',
        TaxRate: '税率',
        Member: 'メンバー',
        MemberOnly: 'メンバーのみ',
        NonMember: '非メンバー',
        Everyone: '全員',
    },
    kr: {
        ActiveThisRule: '이 규칙 활성화',
        Name: '이름',
        Code: '코드',
        AlternateName1: '대체 이름1',
        AlternateName2: '대체 이름2',
        Rate: '세율',
        TaxRate: '세율',
        Member: '회원',
        MemberOnly: '회원만',
        NonMember: '비회원',
        Everyone: '모두',
    },
}

export const promotionDetailsLanguage = {
    en: {
        Basic: 'Basic',
        TimeControl: 'Time Control',
        Trigger: 'Trigger',
        Type: 'Type',
        Delete: 'Delete',
        ModifySave: 'Modify / Save',
        AreYouSure: 'Are you sure?',
        NotRevert: "You won't be able to revert this!",
        Confirm: 'Confirm',
        Deleted: 'Deleted!',
        DeletedMsg: 'Your promotion has been deleted.',
        Success: 'Success!',
        UpdateSuccess: 'Promotion details updated successfully',
        Cancel: 'Cancel',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        TimeControl: 'ควบคุมเวลา',
        Trigger: 'ทริกเกอร์',
        Type: 'ประเภท',
        Delete: 'ลบ',
        ModifySave: 'แก้ไข / บันทึก',
        AreYouSure: 'คุณแน่ใจหรือไม่?',
        NotRevert: 'คุณจะไม่สามารถย้อนกลับได้!',
        Confirm: 'ยืนยัน',
        Deleted: 'ลบแล้ว!',
        DeletedMsg: 'โปรโมชันของคุณถูกลบแล้ว',
        Success: 'สำเร็จ!',
        UpdateSuccess: 'อัปเดตรายละเอียดโปรโมชันสำเร็จ',
        Cancel: 'ยกเลิก',
    },
    cn: {
        Basic: '基本信息',
        TimeControl: '时间控制',
        Trigger: '触发器',
        Type: '类型',
        Delete: '删除',
        ModifySave: '修改 / 保存',
        AreYouSure: '你确定吗？',
        NotRevert: '此操作无法撤销！',
        Confirm: '确认',
        Deleted: '已删除！',
        DeletedMsg: '您的促销已被删除。',
        Success: '成功！',
        UpdateSuccess: '促销详情更新成功',
        Cancel: '取消',
    },
    jp: {
        Basic: '基本情報',
        TimeControl: '時間制御',
        Trigger: 'トリガー',
        Type: 'タイプ',
        Delete: '削除',
        ModifySave: '修正 / 保存',
        AreYouSure: 'よろしいですか？',
        NotRevert: 'この操作は元に戻せません！',
        Confirm: '確認',
        Deleted: '削除されました！',
        DeletedMsg: 'プロモーションが削除されました。',
        Success: '成功！',
        UpdateSuccess: 'プロモーションの詳細が正常に更新されました',
        Cancel: 'キャンセル',
    },
    kr: {
        Basic: '기본 정보',
        TimeControl: '시간 제어',
        Trigger: '트리거',
        Type: '유형',
        Delete: '삭제',
        ModifySave: '수정 / 저장',
        AreYouSure: '확실합니까?',
        NotRevert: '이 작업은 되돌릴 수 없습니다!',
        Confirm: '확인',
        Deleted: '삭제됨!',
        DeletedMsg: '프로모션이 삭제되었습니다.',
        Success: '성공!',
        UpdateSuccess: '프로모션 세부정보가 성공적으로 업데이트되었습니다',
        Cancel: '취소',
    },
}

export const promotionListLanguage = {
    en: {
        Add: 'Add',
        ProductPromotions: 'Product Promotions',
    },
    th: {
        Add: 'เพิ่ม',
        ProductPromotions: 'โปรโมชันสินค้า',
    },
    cn: {
        Add: '添加',
        ProductPromotions: '产品促销',
    },
    jp: {
        Add: '追加',
        ProductPromotions: '商品プロモーション',
    },
    kr: {
        Add: '추가',
        ProductPromotions: '상품 프로모션',
    },
}

export const promotionModalLanguage = {
    en: {
        Title: 'New Promotion Rule',
        RuleName: 'Rule Name',
        RuleNamePlaceholder: 'Rule Name',
        RuleCode: 'Rule Code',
        RuleCodePlaceholder: 'Rule Code',
        OK: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        Title: 'กฎโปรโมชันใหม่',
        RuleName: 'ชื่อกฎ',
        RuleNamePlaceholder: 'ชื่อกฎ',
        RuleCode: 'รหัสกฎ',
        RuleCodePlaceholder: 'รหัสกฎ',
        OK: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        Title: '新促销规则',
        RuleName: '规则名称',
        RuleNamePlaceholder: '规则名称',
        RuleCode: '规则代码',
        RuleCodePlaceholder: '规则代码',
        OK: '确定',
        Cancel: '取消',
    },
    jp: {
        Title: '新しいプロモーションルール',
        RuleName: 'ルール名',
        RuleNamePlaceholder: 'ルール名',
        RuleCode: 'ルールコード',
        RuleCodePlaceholder: 'ルールコード',
        OK: 'OK',
        Cancel: 'キャンセル',
    },
    kr: {
        Title: '새 프로모션 규칙',
        RuleName: '규칙 이름',
        RuleNamePlaceholder: '규칙 이름',
        RuleCode: '규칙 코드',
        RuleCodePlaceholder: '규칙 코드',
        OK: '확인',
        Cancel: '취소',
    },
}

export const promotionTimeControlLanguage = {
    en: {
        PromotionPeriodDateRange: 'Promotion Period - Date Range',
        StartDate: 'Start Date',
        EndDate: 'End Date',
        PromotionPeriodTimeOfDay: 'Promotion Period - Time of Day',
        StartTime: 'Start Time',
        EndTime: 'End Time',
        DaysOfWeek: 'Days of Week',
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
    },
    th: {
        PromotionPeriodDateRange: 'ช่วงเวลาโปรโมชั่น - ช่วงวันที่',
        StartDate: 'วันที่เริ่มต้น',
        EndDate: 'วันที่สิ้นสุด',
        PromotionPeriodTimeOfDay: 'ช่วงเวลาโปรโมชั่น - ช่วงเวลาในวัน',
        StartTime: 'เวลาเริ่มต้น',
        EndTime: 'เวลาสิ้นสุด',
        DaysOfWeek: 'วันในสัปดาห์',
        Sunday: 'วันอาทิตย์',
        Monday: 'วันจันทร์',
        Tuesday: 'วันอังคาร',
        Wednesday: 'วันพุธ',
        Thursday: 'วันพฤหัสบดี',
        Friday: 'วันศุกร์',
        Saturday: 'วันเสาร์',
    },
    cn: {
        PromotionPeriodDateRange: '促销期 - 日期范围',
        StartDate: '开始日期',
        EndDate: '结束日期',
        PromotionPeriodTimeOfDay: '促销期 - 每日时间段',
        StartTime: '开始时间',
        EndTime: '结束时间',
        DaysOfWeek: '星期几',
        Sunday: '星期日',
        Monday: '星期一',
        Tuesday: '星期二',
        Wednesday: '星期三',
        Thursday: '星期四',
        Friday: '星期五',
        Saturday: '星期六',
    },
    jp: {
        PromotionPeriodDateRange: 'プロモーション期間 - 日付範囲',
        StartDate: '開始日',
        EndDate: '終了日',
        PromotionPeriodTimeOfDay: 'プロモーション期間 - 時間帯',
        StartTime: '開始時間',
        EndTime: '終了時間',
        DaysOfWeek: '曜日',
        Sunday: '日曜日',
        Monday: '月曜日',
        Tuesday: '火曜日',
        Wednesday: '水曜日',
        Thursday: '木曜日',
        Friday: '金曜日',
        Saturday: '土曜日',
    },
    kr: {
        PromotionPeriodDateRange: '프로모션 기간 - 날짜 범위',
        StartDate: '시작 날짜',
        EndDate: '종료 날짜',
        PromotionPeriodTimeOfDay: '프로모션 기간 - 하루 중 시간',
        StartTime: '시작 시간',
        EndTime: '종료 시간',
        DaysOfWeek: '요일',
        Sunday: '일요일',
        Monday: '월요일',
        Tuesday: '화요일',
        Wednesday: '수요일',
        Thursday: '목요일',
        Friday: '금요일',
        Saturday: '토요일',
    },
}

export const promotionTriggerLanguage = {
    en: {
        SelectTrigger: 'Select Trigger',
        Description: 'Description',
        IndividualDepartment: 'Individual Department',
        MultiDepartment: 'Multi Department',
        IndividualGroup: 'Individual Group',
        MultiProductGroup: 'Multi Product Group',
        IndividualPLU: 'Individual PLU',
    },
    th: {
        SelectTrigger: 'เลือกทริกเกอร์',
        Description: 'รายละเอียด',
        IndividualDepartment: 'แผนกเดี่ยว',
        MultiDepartment: 'หลายแผนก',
        IndividualGroup: 'กลุ่มเดี่ยว',
        MultiProductGroup: 'หลายกลุ่มสินค้า',
        IndividualPLU: 'PLU เดี่ยว',
    },
    cn: {
        SelectTrigger: '选择触发器',
        Description: '描述',
        IndividualDepartment: '单个部门',
        MultiDepartment: '多个部门',
        IndividualGroup: '单个组',
        MultiProductGroup: '多个产品组',
        IndividualPLU: '单个PLU',
    },
    jp: {
        SelectTrigger: 'トリガーを選択',
        Description: '説明',
        IndividualDepartment: '個別部門',
        MultiDepartment: '複数部門',
        IndividualGroup: '個別グループ',
        MultiProductGroup: '複数商品グループ',
        IndividualPLU: '個別PLU',
    },
    kr: {
        SelectTrigger: '트리거 선택',
        Description: '설명',
        IndividualDepartment: '개별 부서',
        MultiDepartment: '다중 부서',
        IndividualGroup: '개별 그룹',
        MultiProductGroup: '다중 상품 그룹',
        IndividualPLU: '개별 PLU',
    },
}

export const promotionTypeLanguage = {
    en: {
        SelectType: 'Select Type',
        Description: 'Description',
        MultiBuy: 'Multi Buy',
        FixedValue: 'Fixed Value',
        PercentageOff: 'Percentage Off',
        CheapestOneFree: 'Cheapest One Free',
        DiscountAfterN: 'Discount After N',
        BuyXGetYFree: 'Buy X Get Y Free',
        AmountOff: 'Amount Off',
    },
    th: {
        SelectType: 'เลือกประเภท',
        Description: 'รายละเอียด',
        MultiBuy: 'ซื้อหลายชิ้น',
        FixedValue: 'มูลค่าคงที่',
        PercentageOff: 'ลดเปอร์เซ็นต์',
        CheapestOneFree: 'ซื้อหลายชิ้น ฟรีชิ้นที่ถูกสุด',
        DiscountAfterN: 'ลดราคาหลังจาก N ชิ้น',
        BuyXGetYFree: 'ซื้อ X แถม Y',
        AmountOff: 'ลดตามจำนวนเงิน',
    },
    cn: {
        SelectType: '选择类型',
        Description: '描述',
        MultiBuy: '多件购买',
        FixedValue: '固定值',
        PercentageOff: '百分比折扣',
        CheapestOneFree: '最便宜的免费',
        DiscountAfterN: 'N件后折扣',
        BuyXGetYFree: '买X送Y',
        AmountOff: '减金额',
    },
    jp: {
        SelectType: 'タイプを選択',
        Description: '説明',
        MultiBuy: '複数購入',
        FixedValue: '固定値',
        PercentageOff: 'パーセントオフ',
        CheapestOneFree: '最安値無料',
        DiscountAfterN: 'N個目以降割引',
        BuyXGetYFree: 'X個買うとY個無料',
        AmountOff: '金額割引',
    },
    kr: {
        SelectType: '유형 선택',
        Description: '설명',
        MultiBuy: '다중 구매',
        FixedValue: '고정 금액',
        PercentageOff: '퍼센트 할인',
        CheapestOneFree: '가장 저렴한 상품 무료',
        DiscountAfterN: 'N개 이후 할인',
        BuyXGetYFree: 'X개 구매시 Y개 무료',
        AmountOff: '금액 할인',
    },
}

export const promotionTriggerIndividualDepartmentLanguage = {
    en: {
        Options: 'Options',
        Department: 'Department',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        TriggerAmountType: 'Trigger Amount Type',
        ByQuantity: 'By Quantity',
        BySubtotal: 'By Subtotal',
        Rate: 'Rate',
        Threshold: 'Threshold',
        TriggerAmountMode: 'Trigger Amount Mode',
        Single: 'Single',
        MoreThan: 'More Than',
        Multiple: 'Multiple',
        ApplicableDestination: 'Applicable Destination',
        ApplicableDestinationPlaceholder: 'Applicable Destination',
        Internal: 'Internal',
        Mart: 'Mart',
    },
    th: {
        Options: 'ตัวเลือก',
        Department: 'แผนก',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        TriggerAmountType: 'ประเภทจำนวนทริกเกอร์',
        ByQuantity: 'ตามจำนวน',
        BySubtotal: 'ตามยอดรวม',
        Rate: 'อัตรา',
        Threshold: 'เกณฑ์',
        TriggerAmountMode: 'โหมดจำนวนทริกเกอร์',
        Single: 'เดี่ยว',
        MoreThan: 'มากกว่า',
        Multiple: 'หลายรายการ',
        ApplicableDestination: 'ปลายทางที่ใช้ได้',
        ApplicableDestinationPlaceholder: 'ปลายทางที่ใช้ได้',
        Internal: 'ภายใน',
        Mart: 'มาร์ท',
    },
    cn: {
        Options: '选项',
        Department: '部门',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        TriggerAmountType: '触发数量类型',
        ByQuantity: '按数量',
        BySubtotal: '按小计',
        Rate: '税率',
        Threshold: '阈值',
        TriggerAmountMode: '触发数量模式',
        Single: '单个',
        MoreThan: '大于',
        Multiple: '多个',
        ApplicableDestination: '适用目的地',
        ApplicableDestinationPlaceholder: '适用目的地',
        Internal: '内部',
        Mart: '超市',
    },
    jp: {
        Options: 'オプション',
        Department: '部門',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        TriggerAmountType: 'トリガー数量タイプ',
        ByQuantity: '数量で',
        BySubtotal: '小計で',
        Rate: '税率',
        Threshold: 'しきい値',
        TriggerAmountMode: 'トリガー数量モード',
        Single: '単一',
        MoreThan: 'より多い',
        Multiple: '複数',
        ApplicableDestination: '適用先',
        ApplicableDestinationPlaceholder: '適用先',
        Internal: '内部',
        Mart: 'マート',
    },
    kr: {
        Options: '옵션',
        Department: '부서',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        TriggerAmountType: '트리거 수량 유형',
        ByQuantity: '수량별',
        BySubtotal: '소계별',
        Rate: '세율',
        Threshold: '임계값',
        TriggerAmountMode: '트리거 수량 모드',
        Single: '단일',
        MoreThan: '이상',
        Multiple: '여러 개',
        ApplicableDestination: '적용 대상',
        ApplicableDestinationPlaceholder: '적용 대상',
        Internal: '내부',
        Mart: '마트',
    },
}

export const promotionTriggerIndividualGroupLanguage = {
    en: {
        Options: 'Options',
        ProductGroup: 'Product Group',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        TriggerAmountType: 'Trigger Amount Type',
        ByQuantity: 'By Quantity',
        BySubtotal: 'By Subtotal',
        Rate: 'Rate',
        Threshold: 'Threshold',
        TriggerAmountMode: 'Trigger Amount Mode',
        Single: 'Single',
        MoreThan: 'More Than',
        Multiple: 'Multiple',
        ApplicableDestination: 'Applicable Destination',
        ApplicableDestinationPlaceholder: 'Applicable Destination',
        Internal: 'Internal',
        Mart: 'Mart',
    },
    th: {
        Options: 'ตัวเลือก',
        ProductGroup: 'กลุ่มสินค้า',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        TriggerAmountType: 'ประเภทจำนวนทริกเกอร์',
        ByQuantity: 'ตามจำนวน',
        BySubtotal: 'ตามยอดรวม',
        Rate: 'อัตรา',
        Threshold: 'เกณฑ์',
        TriggerAmountMode: 'โหมดจำนวนทริกเกอร์',
        Single: 'เดี่ยว',
        MoreThan: 'มากกว่า',
        Multiple: 'หลายรายการ',
        ApplicableDestination: 'ปลายทางที่ใช้ได้',
        ApplicableDestinationPlaceholder: 'ปลายทางที่ใช้ได้',
        Internal: 'ภายใน',
        Mart: 'มาร์ท',
    },
    cn: {
        Options: '选项',
        ProductGroup: '产品组',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        TriggerAmountType: '触发数量类型',
        ByQuantity: '按数量',
        BySubtotal: '按小计',
        Rate: '税率',
        Threshold: '阈值',
        TriggerAmountMode: '触发数量模式',
        Single: '单个',
        MoreThan: '大于',
        Multiple: '多个',
        ApplicableDestination: '适用目的地',
        ApplicableDestinationPlaceholder: '适用目的地',
        Internal: '内部',
        Mart: '超市',
    },
    jp: {
        Options: 'オプション',
        ProductGroup: '商品グループ',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        TriggerAmountType: 'トリガー数量タイプ',
        ByQuantity: '数量で',
        BySubtotal: '小計で',
        Rate: '税率',
        Threshold: 'しきい値',
        TriggerAmountMode: 'トリガー数量モード',
        Single: '単一',
        MoreThan: 'より多い',
        Multiple: '複数',
        ApplicableDestination: '適用先',
        ApplicableDestinationPlaceholder: '適用先',
        Internal: '内部',
        Mart: 'マート',
    },
    kr: {
        Options: '옵션',
        ProductGroup: '상품 그룹',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        TriggerAmountType: '트리거 수량 유형',
        ByQuantity: '수량별',
        BySubtotal: '소계별',
        Rate: '세율',
        Threshold: '임계값',
        TriggerAmountMode: '트리거 수량 모드',
        Single: '단일',
        MoreThan: '이상',
        Multiple: '여러 개',
        ApplicableDestination: '적용 대상',
        ApplicableDestinationPlaceholder: '적용 대상',
        Internal: '내부',
        Mart: '마트',
    },
}

export const promotionTriggerIndividualPLULanguage = {
    en: {
        Options: 'Options',
        PLU: 'PLU',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        TriggerAmountType: 'Trigger Amount Type',
        ByQuantity: 'By Quantity',
        BySubtotal: 'By Subtotal',
        Rate: 'Rate',
        Threshold: 'Threshold',
        TriggerAmountMode: 'Trigger Amount Mode',
        Single: 'Single',
        MoreThan: 'More Than',
        Multiple: 'Multiple',
        ApplicableDestination: 'Applicable Destination',
        ApplicableDestinationPlaceholder: 'Applicable Destination',
        Internal: 'Internal',
        Mart: 'Mart',
        PLUNO: 'PLU NO',
        PLUName: 'PLU Name',
        AddSetItem: 'Add Set Item',
        Remove: 'Remove',
    },
    th: {
        Options: 'ตัวเลือก',
        PLU: 'PLU',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        TriggerAmountType: 'ประเภทจำนวนทริกเกอร์',
        ByQuantity: 'ตามจำนวน',
        BySubtotal: 'ตามยอดรวม',
        Rate: 'อัตรา',
        Threshold: 'เกณฑ์',
        TriggerAmountMode: 'โหมดจำนวนทริกเกอร์',
        Single: 'เดี่ยว',
        MoreThan: 'มากกว่า',
        Multiple: 'หลายรายการ',
        ApplicableDestination: 'ปลายทางที่ใช้ได้',
        ApplicableDestinationPlaceholder: 'ปลายทางที่ใช้ได้',
        Internal: 'ภายใน',
        Mart: 'มาร์ท',
        PLUNO: 'รหัส PLU',
        PLUName: 'ชื่อ PLU',
        AddSetItem: 'เพิ่มชุดรายการ',
        Remove: 'ลบ',
    },
    cn: {
        Options: '选项',
        PLU: 'PLU',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        TriggerAmountType: '触发数量类型',
        ByQuantity: '按数量',
        BySubtotal: '按小计',
        Rate: '税率',
        Threshold: '阈值',
        TriggerAmountMode: '触发数量模式',
        Single: '单个',
        MoreThan: '大于',
        Multiple: '多个',
        ApplicableDestination: '适用目的地',
        ApplicableDestinationPlaceholder: '适用目的地',
        Internal: '内部',
        Mart: '超市',
        PLUNO: 'PLU编号',
        PLUName: 'PLU名称',
        AddSetItem: '添加组合项',
        Remove: '移除',
    },
    jp: {
        Options: 'オプション',
        PLU: 'PLU',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        TriggerAmountType: 'トリガー数量タイプ',
        ByQuantity: '数量で',
        BySubtotal: '小計で',
        Rate: '税率',
        Threshold: 'しきい値',
        TriggerAmountMode: 'トリガー数量モード',
        Single: '単一',
        MoreThan: 'より多い',
        Multiple: '複数',
        ApplicableDestination: '適用先',
        ApplicableDestinationPlaceholder: '適用先',
        Internal: '内部',
        Mart: 'マート',
        PLUNO: 'PLU番号',
        PLUName: 'PLU名',
        AddSetItem: 'セットアイテムを追加',
        Remove: '削除',
    },
    kr: {
        Options: '옵션',
        PLU: 'PLU',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        TriggerAmountType: '트리거 수량 유형',
        ByQuantity: '수량별',
        BySubtotal: '소계별',
        Rate: '세율',
        Threshold: '임계값',
        TriggerAmountMode: '트리거 수량 모드',
        Single: '단일',
        MoreThan: '이상',
        Multiple: '여러 개',
        ApplicableDestination: '적용 대상',
        ApplicableDestinationPlaceholder: '적용 대상',
        Internal: '내부',
        Mart: '마트',
        PLUNO: 'PLU 번호',
        PLUName: 'PLU 이름',
        AddSetItem: '세트 항목 추가',
        Remove: '삭제',
    },
}

export const promotionTriggerMultiDepartmentLanguage = {
    en: {
        Options: 'Options',
        FirstDepartment: 'First Department',
        SecondDepartment: 'Second Department',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        TriggerAmountType: 'Trigger Amount Type',
        ByQuantity: 'By Quantity',
        BySubtotal: 'By Subtotal',
        Rate: 'Rate',
        Threshold: 'Threshold',
        TriggerAmountMode: 'Trigger Amount Mode',
        Single: 'Single',
        MoreThan: 'More Than',
        Multiple: 'Multiple',
        ApplicableDestination: 'Applicable Destination',
        ApplicableDestinationPlaceholder: 'Applicable Destination',
        Internal: 'Internal',
        Mart: 'Mart',
        Department: 'Department',
    },
    th: {
        Options: 'ตัวเลือก',
        FirstDepartment: 'แผนกแรก',
        SecondDepartment: 'แผนกที่สอง',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        TriggerAmountType: 'ประเภทจำนวนทริกเกอร์',
        ByQuantity: 'ตามจำนวน',
        BySubtotal: 'ตามยอดรวม',
        Rate: 'อัตรา',
        Threshold: 'เกณฑ์',
        TriggerAmountMode: 'โหมดจำนวนทริกเกอร์',
        Single: 'เดี่ยว',
        MoreThan: 'มากกว่า',
        Multiple: 'หลายรายการ',
        ApplicableDestination: 'ปลายทางที่ใช้ได้',
        ApplicableDestinationPlaceholder: 'ปลายทางที่ใช้ได้',
        Internal: 'ภายใน',
        Mart: 'มาร์ท',
        Department: 'แผนก',
    },
    cn: {
        Options: '选项',
        FirstDepartment: '第一个部门',
        SecondDepartment: '第二个部门',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        TriggerAmountType: '触发数量类型',
        ByQuantity: '按数量',
        BySubtotal: '按小计',
        Rate: '税率',
        Threshold: '阈值',
        TriggerAmountMode: '触发数量模式',
        Single: '单个',
        MoreThan: '大于',
        Multiple: '多个',
        ApplicableDestination: '适用目的地',
        ApplicableDestinationPlaceholder: '适用目的地',
        Internal: '内部',
        Mart: '超市',
        Department: '部门',
    },
    jp: {
        Options: 'オプション',
        FirstDepartment: '最初の部門',
        SecondDepartment: '2番目の部門',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        TriggerAmountType: 'トリガー数量タイプ',
        ByQuantity: '数量で',
        BySubtotal: '小計で',
        Rate: '税率',
        Threshold: 'しきい値',
        TriggerAmountMode: 'トリガー数量モード',
        Single: '単一',
        MoreThan: 'より多い',
        Multiple: '複数',
        ApplicableDestination: '適用先',
        ApplicableDestinationPlaceholder: '適用先',
        Internal: '内部',
        Mart: 'マート',
        Department: '部門',
    },
    kr: {
        Options: '옵션',
        FirstDepartment: '첫 번째 부서',
        SecondDepartment: '두 번째 부서',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        TriggerAmountType: '트리거 수량 유형',
        ByQuantity: '수량별',
        BySubtotal: '소계별',
        Rate: '세율',
        Threshold: '임계값',
        TriggerAmountMode: '트리거 수량 모드',
        Single: '단일',
        MoreThan: '이상',
        Multiple: '여러 개',
        ApplicableDestination: '적용 대상',
        ApplicableDestinationPlaceholder: '적용 대상',
        Internal: '내부',
        Mart: '마트',
        Department: '부서',
    },
}

export const promotionTriggerMultiProductGroupLanguage = {
    en: {
        Options: 'Options',
        FirstProductGroup: 'First Product Group',
        SecondProductGroup: 'Second Product Group',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        TriggerAmountType: 'Trigger Amount Type',
        ByQuantity: 'By Quantity',
        BySubtotal: 'By Subtotal',
        Rate: 'Rate',
        Threshold: 'Threshold',
        TriggerAmountMode: 'Trigger Amount Mode',
        Single: 'Single',
        MoreThan: 'More Than',
        Multiple: 'Multiple',
        ApplicableDestination: 'Applicable Destination',
        ApplicableDestinationPlaceholder: 'Applicable Destination',
        Internal: 'Internal',
        Mart: 'Mart',
        ProductGroup: 'Product Group',
    },
    th: {
        Options: 'ตัวเลือก',
        FirstProductGroup: 'กลุ่มสินค้าแรก',
        SecondProductGroup: 'กลุ่มสินค้าที่สอง',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        TriggerAmountType: 'ประเภทจำนวนทริกเกอร์',
        ByQuantity: 'ตามจำนวน',
        BySubtotal: 'ตามยอดรวม',
        Rate: 'อัตรา',
        Threshold: 'เกณฑ์',
        TriggerAmountMode: 'โหมดจำนวนทริกเกอร์',
        Single: 'เดี่ยว',
        MoreThan: 'มากกว่า',
        Multiple: 'หลายรายการ',
        ApplicableDestination: 'ปลายทางที่ใช้ได้',
        ApplicableDestinationPlaceholder: 'ปลายทางที่ใช้ได้',
        Internal: 'ภายใน',
        Mart: 'มาร์ท',
        ProductGroup: 'กลุ่มสินค้า',
    },
    cn: {
        Options: '选项',
        FirstProductGroup: '第一个产品组',
        SecondProductGroup: '第二个产品组',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        TriggerAmountType: '触发数量类型',
        ByQuantity: '按数量',
        BySubtotal: '按小计',
        Rate: '税率',
        Threshold: '阈值',
        TriggerAmountMode: '触发数量模式',
        Single: '单个',
        MoreThan: '大于',
        Multiple: '多个',
        ApplicableDestination: '适用目的地',
        ApplicableDestinationPlaceholder: '适用目的地',
        Internal: '内部',
        Mart: '超市',
        ProductGroup: '产品组',
    },
    jp: {
        Options: 'オプション',
        FirstProductGroup: '最初の商品グループ',
        SecondProductGroup: '2番目の商品グループ',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        TriggerAmountType: 'トリガー数量タイプ',
        ByQuantity: '数量で',
        BySubtotal: '小計で',
        Rate: '税率',
        Threshold: 'しきい値',
        TriggerAmountMode: 'トリガー数量モード',
        Single: '単一',
        MoreThan: 'より多い',
        Multiple: '複数',
        ApplicableDestination: '適用先',
        ApplicableDestinationPlaceholder: '適用先',
        Internal: '内部',
        Mart: 'マート',
        ProductGroup: '商品グループ',
    },
    kr: {
        Options: '옵션',
        FirstProductGroup: '첫 번째 상품 그룹',
        SecondProductGroup: '두 번째 상품 그룹',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        TriggerAmountType: '트리거 수량 유형',
        ByQuantity: '수량별',
        BySubtotal: '소계별',
        Rate: '세율',
        Threshold: '임계값',
        TriggerAmountMode: '트리거 수량 모드',
        Single: '단일',
        MoreThan: '이상',
        Multiple: '여러 개',
        ApplicableDestination: '적용 대상',
        ApplicableDestinationPlaceholder: '적용 대상',
        Internal: '내부',
        Mart: '마트',
        ProductGroup: '상품 그룹',
    },
}

export const promotionTypeAmountOffLanguage = {
    en: {
        DiscountType: 'Discount Type',
        ByQuantity: 'By Quantity',
        BySubtotal: 'By Subtotal',
        MultiBuyQuantity: 'Multi-Buy Quantity',
        Quantity: 'Quantity',
    },
    th: {
        DiscountType: 'ประเภทส่วนลด',
        ByQuantity: 'ตามจำนวน',
        BySubtotal: 'ตามยอดรวม',
        MultiBuyQuantity: 'จำนวนซื้อหลายชิ้น',
        Quantity: 'จำนวน',
    },
    cn: {
        DiscountType: '折扣类型',
        ByQuantity: '按数量',
        BySubtotal: '按小计',
        MultiBuyQuantity: '多件购买数量',
        Quantity: '数量',
    },
    jp: {
        DiscountType: '割引タイプ',
        ByQuantity: '数量で',
        BySubtotal: '小計で',
        MultiBuyQuantity: '複数購入数',
        Quantity: '数量',
    },
    kr: {
        DiscountType: '할인 유형',
        ByQuantity: '수량별',
        BySubtotal: '소계별',
        MultiBuyQuantity: '다중 구매 수량',
        Quantity: '수량',
    },
}

export const promotionTypeBuyXGetYFreeLanguage = {
    en: {
        Grouping: 'Grouping',
        PriceComputation: 'Price Computation',
        DiscountComputation: 'Discount Computation',
        RoundingFactor: 'Rounding Factor',
        RoundingPolicy: 'Rounding Policy',
        RoundingPolicyPlaceholder: 'Rounding Policy',
        RoundAvgPriceIndividually: 'Round Average Price Individually',
        DiscountOncePerGroup: 'Discount Once per Group',
        IncludeCondiments: 'Include Condiments',
        IncludeItemDiscount: 'Include Item Discount',
        IncludeItemSurCharge: 'Include Item Surcharge',
        IncludeAddOnServiceCharges: 'Include Add-on Service Charges',
        X: 'X',
        Y: 'Y',
        Quantity: 'Quantity',
        OnlyReserveDiscountedItems: 'Only Reserve Discounted Items',
        ExcludeFreeItems: 'Exclude Free Items',
        GroupItemBy: 'Group Item By',
        NoGrouping: 'No Grouping',
        Price: 'Price',
        Product: 'Product',
    },
    th: {
        Grouping: 'การจัดกลุ่ม',
        PriceComputation: 'การคำนวณราคา',
        DiscountComputation: 'การคำนวณส่วนลด',
        RoundingFactor: 'ตัวประกอบการปัดเศษ',
        RoundingPolicy: 'นโยบายการปัดเศษ',
        RoundingPolicyPlaceholder: 'นโยบายการปัดเศษ',
        RoundAvgPriceIndividually: 'ปัดเศษราคาต่อชิ้น',
        DiscountOncePerGroup: 'ลดราคาต่อกลุ่มเพียงครั้งเดียว',
        IncludeCondiments: 'รวมเครื่องปรุง',
        IncludeItemDiscount: 'รวมส่วนลดต่อรายการ',
        IncludeItemSurCharge: 'รวมค่าบริการต่อรายการ',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        X: 'X',
        Y: 'Y',
        Quantity: 'จำนวน',
        OnlyReserveDiscountedItems: 'สงวนเฉพาะรายการที่ลดราคา',
        ExcludeFreeItems: 'ไม่รวมรายการฟรี',
        GroupItemBy: 'จัดกลุ่มรายการโดย',
        NoGrouping: 'ไม่จัดกลุ่ม',
        Price: 'ราคา',
        Product: 'สินค้า',
    },
    cn: {
        Grouping: '分组',
        PriceComputation: '价格计算',
        DiscountComputation: '折扣计算',
        RoundingFactor: '舍入因子',
        RoundingPolicy: '舍入策略',
        RoundingPolicyPlaceholder: '舍入策略',
        RoundAvgPriceIndividually: '分别舍入平均价',
        DiscountOncePerGroup: '每组仅折扣一次',
        IncludeCondiments: '包含调味品',
        IncludeItemDiscount: '包含项目折扣',
        IncludeItemSurCharge: '包含项目附加费',
        IncludeAddOnServiceCharges: '包含附加服务费',
        X: 'X',
        Y: 'Y',
        Quantity: '数量',
        OnlyReserveDiscountedItems: '仅保留折扣商品',
        ExcludeFreeItems: '排除免费商品',
        GroupItemBy: '分组方式',
        NoGrouping: '不分组',
        Price: '价格',
        Product: '商品',
    },
    jp: {
        Grouping: 'グルーピング',
        PriceComputation: '価格計算',
        DiscountComputation: '割引計算',
        RoundingFactor: '丸め係数',
        RoundingPolicy: '丸め方針',
        RoundingPolicyPlaceholder: '丸め方針',
        RoundAvgPriceIndividually: '平均価格を個別に丸める',
        DiscountOncePerGroup: 'グループごとに一度だけ割引',
        IncludeCondiments: '調味料を含める',
        IncludeItemDiscount: 'アイテム割引を含める',
        IncludeItemSurCharge: 'アイテム追加料金を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        X: 'X',
        Y: 'Y',
        Quantity: '数量',
        OnlyReserveDiscountedItems: '割引対象商品のみ予約',
        ExcludeFreeItems: '無料商品を除外',
        GroupItemBy: 'グループ化方法',
        NoGrouping: 'グループ化しない',
        Price: '価格',
        Product: '商品',
    },
    kr: {
        Grouping: '그룹화',
        PriceComputation: '가격 계산',
        DiscountComputation: '할인 계산',
        RoundingFactor: '반올림 계수',
        RoundingPolicy: '반올림 정책',
        RoundingPolicyPlaceholder: '반올림 정책',
        RoundAvgPriceIndividually: '평균 가격 개별 반올림',
        DiscountOncePerGroup: '그룹당 한 번만 할인',
        IncludeCondiments: '조미료 포함',
        IncludeItemDiscount: '항목 할인 포함',
        IncludeItemSurCharge: '항목 추가요금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        X: 'X',
        Y: 'Y',
        Quantity: '수량',
        OnlyReserveDiscountedItems: '할인된 항목만 예약',
        ExcludeFreeItems: '무료 항목 제외',
        GroupItemBy: '그룹화 기준',
        NoGrouping: '그룹화 없음',
        Price: '가격',
        Product: '상품',
    },
}

export const promotionTypeCheapestOneFreeLanguage = {
    en: {
        Basic: 'Basic',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        DiscountType: 'Discount Type',
        FixedValue: 'Fixed Value',
        AmountOff: 'Amount Off',
        PercentageOff: 'Percentage Off',
        MaximumQuantity: 'Maximum Quantity',
        DiscountValue: 'Discount Value',
        Quantity: 'Quantity',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        DiscountType: 'ประเภทส่วนลด',
        FixedValue: 'มูลค่าคงที่',
        AmountOff: 'ลดตามจำนวนเงิน',
        PercentageOff: 'ลดเปอร์เซ็นต์',
        MaximumQuantity: 'จำนวนสูงสุด',
        DiscountValue: 'มูลค่าส่วนลด',
        Quantity: 'จำนวน',
    },
    cn: {
        Basic: '基本信息',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        DiscountType: '折扣类型',
        FixedValue: '固定值',
        AmountOff: '减金额',
        PercentageOff: '百分比折扣',
        MaximumQuantity: '最大数量',
        DiscountValue: '折扣值',
        Quantity: '数量',
    },
    jp: {
        Basic: '基本情報',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        DiscountType: '割引タイプ',
        FixedValue: '固定値',
        AmountOff: '金額割引',
        PercentageOff: 'パーセントオフ',
        MaximumQuantity: '最大数量',
        DiscountValue: '割引額',
        Quantity: '数量',
    },
    kr: {
        Basic: '기본 정보',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        DiscountType: '할인 유형',
        FixedValue: '고정 금액',
        AmountOff: '금액 할인',
        PercentageOff: '퍼센트 할인',
        MaximumQuantity: '최대 수량',
        DiscountValue: '할인 금액',
        Quantity: '수량',
    },
}

export const promotionTypeDiscountAfterNLanguage = {
    en: {
        Basic: 'Basic',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        DiscountThresholdQuantity: 'Discount Threshold Quantity',
        DiscountType: 'Discount Type',
        FixedValue: 'Fixed Value',
        AmountOff: 'Amount Off',
        PercentageOff: 'Percentage Off',
        MaximumQuantity: 'Maximum Quantity',
        DiscountValue: 'Discount Value',
        Quantity: 'Quantity',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        DiscountThresholdQuantity: 'จำนวนขั้นต่ำเพื่อรับส่วนลด',
        DiscountType: 'ประเภทส่วนลด',
        FixedValue: 'มูลค่าคงที่',
        AmountOff: 'ลดตามจำนวนเงิน',
        PercentageOff: 'ลดเปอร์เซ็นต์',
        MaximumQuantity: 'จำนวนสูงสุด',
        DiscountValue: 'มูลค่าส่วนลด',
        Quantity: 'จำนวน',
    },
    cn: {
        Basic: '基本信息',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        DiscountThresholdQuantity: '折扣门槛数量',
        DiscountType: '折扣类型',
        FixedValue: '固定值',
        AmountOff: '减金额',
        PercentageOff: '百分比折扣',
        MaximumQuantity: '最大数量',
        DiscountValue: '折扣值',
        Quantity: '数量',
    },
    jp: {
        Basic: '基本情報',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        DiscountThresholdQuantity: '割引しきい値数量',
        DiscountType: '割引タイプ',
        FixedValue: '固定値',
        AmountOff: '金額割引',
        PercentageOff: 'パーセントオフ',
        MaximumQuantity: '最大数量',
        DiscountValue: '割引額',
        Quantity: '数量',
    },
    kr: {
        Basic: '기본 정보',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        DiscountThresholdQuantity: '할인 임계값 수량',
        DiscountType: '할인 유형',
        FixedValue: '고정 금액',
        AmountOff: '금액 할인',
        PercentageOff: '퍼센트 할인',
        MaximumQuantity: '최대 수량',
        DiscountValue: '할인 금액',
        Quantity: '수량',
    },
}

export const promotionTypeFixedValueLanguage = {
    en: {
        Basic: 'Basic',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        DiscountType: 'Discount Type',
        FixedValue: 'Fixed Value',
        AmountOff: 'Amount Off',
        PercentageOff: 'Percentage Off',
        MultiBuyQuantity: 'Multi-Buy Quantity',
        DiscountPrice: 'Discount Price',
        Quantity: 'Quantity',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        DiscountType: 'ประเภทส่วนลด',
        FixedValue: 'มูลค่าคงที่',
        AmountOff: 'ลดตามจำนวนเงิน',
        PercentageOff: 'ลดเปอร์เซ็นต์',
        MultiBuyQuantity: 'จำนวนซื้อหลายชิ้น',
        DiscountPrice: 'ราคาส่วนลด',
        Quantity: 'จำนวน',
    },
    cn: {
        Basic: '基本信息',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        DiscountType: '折扣类型',
        FixedValue: '固定值',
        AmountOff: '减金额',
        PercentageOff: '百分比折扣',
        MultiBuyQuantity: '多件购买数量',
        DiscountPrice: '折扣价',
        Quantity: '数量',
    },
    jp: {
        Basic: '基本情報',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        DiscountType: '割引タイプ',
        FixedValue: '固定値',
        AmountOff: '金額割引',
        PercentageOff: 'パーセントオフ',
        MultiBuyQuantity: '複数購入数',
        DiscountPrice: '割引価格',
        Quantity: '数量',
    },
    kr: {
        Basic: '기본 정보',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        DiscountType: '할인 유형',
        FixedValue: '고정 금액',
        AmountOff: '금액 할인',
        PercentageOff: '퍼센트 할인',
        MultiBuyQuantity: '다중 구매 수량',
        DiscountPrice: '할인가',
        Quantity: '수량',
    },
}

export const promotionTypeMultiBuyLanguage = {
    en: {
        Basic: 'Basic',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        DiscountType: 'Discount Type',
        FixedValue: 'Fixed Value',
        AmountOff: 'Amount Off',
        PercentageOff: 'Percentage Off',
        MultiBuyQuantity: 'Multi-Buy Quantity',
        DiscountPrice: 'Discount Price',
        Quantity: 'Quantity',
        Value: 'Value',
        AddQuantitySetting: 'Add Quantity setting',
        Remove: 'Remove',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        DiscountType: 'ประเภทส่วนลด',
        FixedValue: 'มูลค่าคงที่',
        AmountOff: 'ลดตามจำนวนเงิน',
        PercentageOff: 'ลดเปอร์เซ็นต์',
        MultiBuyQuantity: 'จำนวนซื้อหลายชิ้น',
        DiscountPrice: 'ราคาส่วนลด',
        Quantity: 'จำนวน',
        Value: 'มูลค่า',
        AddQuantitySetting: 'เพิ่มการตั้งค่าจำนวน',
        Remove: 'ลบ',
    },
    cn: {
        Basic: '基本信息',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        DiscountType: '折扣类型',
        FixedValue: '固定值',
        AmountOff: '减金额',
        PercentageOff: '百分比折扣',
        MultiBuyQuantity: '多件购买数量',
        DiscountPrice: '折扣价',
        Quantity: '数量',
        Value: '数值',
        AddQuantitySetting: '添加数量设置',
        Remove: '移除',
    },
    jp: {
        Basic: '基本情報',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        DiscountType: '割引タイプ',
        FixedValue: '固定値',
        AmountOff: '金額割引',
        PercentageOff: 'パーセントオフ',
        MultiBuyQuantity: '複数購入数',
        DiscountPrice: '割引価格',
        Quantity: '数量',
        Value: '値',
        AddQuantitySetting: '数量設定を追加',
        Remove: '削除',
    },
    kr: {
        Basic: '기본 정보',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        DiscountType: '할인 유형',
        FixedValue: '고정 금액',
        AmountOff: '금액 할인',
        PercentageOff: '퍼센트 할인',
        MultiBuyQuantity: '다중 구매 수량',
        DiscountPrice: '할인가',
        Quantity: '수량',
        Value: '값',
        AddQuantitySetting: '수량 설정 추가',
        Remove: '삭제',
    },
}

export const promotionTypeMultiBuyQuantityModalLanguage = {
    en: {
        NewMultiBuyQuantitySetting: 'New Multi-Buy Quantity Setting',
        MultiBuyQuantity: 'Multi-Buy Quantity',
        MultiBuyValue: 'Multi-Buy Value',
        Quantity: 'Quantity',
        Value: 'Value',
        OK: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        NewMultiBuyQuantitySetting: 'ตั้งค่าจำนวนซื้อหลายชิ้นใหม่',
        MultiBuyQuantity: 'จำนวนซื้อหลายชิ้น',
        MultiBuyValue: 'มูลค่าซื้อหลายชิ้น',
        Quantity: 'จำนวน',
        Value: 'มูลค่า',
        OK: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        NewMultiBuyQuantitySetting: '新多件购买设置',
        MultiBuyQuantity: '多件购买数量',
        MultiBuyValue: '多件购买数值',
        Quantity: '数量',
        Value: '数值',
        OK: '确定',
        Cancel: '取消',
    },
    jp: {
        NewMultiBuyQuantitySetting: '新しい複数購入数設定',
        MultiBuyQuantity: '複数購入数',
        MultiBuyValue: '複数購入値',
        Quantity: '数量',
        Value: '値',
        OK: 'OK',
        Cancel: 'キャンセル',
    },
    kr: {
        NewMultiBuyQuantitySetting: '새 다중 구매 수량 설정',
        MultiBuyQuantity: '다중 구매 수량',
        MultiBuyValue: '다중 구매 값',
        Quantity: '수량',
        Value: '값',
        OK: '확인',
        Cancel: '취소',
    },
}

export const promotionTypePercentageOffLanguage = {
    en: {
        Basic: 'Basic',
        SubtotalOptions: 'Subtotal Options',
        IncludeInSubtotal: 'Include in Subtotal',
        IncludeItemDiscount: 'Include item discount/surcharge',
        IncludeAddOnTaxes: 'Include add-on taxes',
        IncludeAddOnServiceCharges: 'Include add-on service charges',
        IncludeCondiments: 'Include condiments',
        ExcludeInSubtotal: 'Exclude in Subtotal',
        ExcludeIncludedTaxes: 'Exclude included taxes',
        ExcludeIncludedServiceCharges: 'Exclude included service charges',
        PercentageOff: 'Percentage Off',
        Quantity: 'Quantity',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        SubtotalOptions: 'ตัวเลือกยอดรวม',
        IncludeInSubtotal: 'รวมในยอดรวม',
        IncludeItemDiscount: 'รวมส่วนลด/ค่าบริการต่อรายการ',
        IncludeAddOnTaxes: 'รวมภาษีเพิ่มเติม',
        IncludeAddOnServiceCharges: 'รวมค่าบริการเพิ่มเติม',
        IncludeCondiments: 'รวมเครื่องปรุง',
        ExcludeInSubtotal: 'ไม่รวมในยอดรวม',
        ExcludeIncludedTaxes: 'ไม่รวมภาษีที่รวมแล้ว',
        ExcludeIncludedServiceCharges: 'ไม่รวมค่าบริการที่รวมแล้ว',
        PercentageOff: 'ลดเปอร์เซ็นต์',
        Quantity: 'จำนวน',
    },
    cn: {
        Basic: '基本信息',
        SubtotalOptions: '小计选项',
        IncludeInSubtotal: '包含在小计中',
        IncludeItemDiscount: '包含项目折扣/附加费',
        IncludeAddOnTaxes: '包含附加税',
        IncludeAddOnServiceCharges: '包含附加服务费',
        IncludeCondiments: '包含调味品',
        ExcludeInSubtotal: '不包含在小计中',
        ExcludeIncludedTaxes: '排除已含税',
        ExcludeIncludedServiceCharges: '排除已含服务费',
        PercentageOff: '百分比折扣',
        Quantity: '数量',
    },
    jp: {
        Basic: '基本情報',
        SubtotalOptions: '小計オプション',
        IncludeInSubtotal: '小計に含める',
        IncludeItemDiscount: 'アイテム割引/追加料金を含める',
        IncludeAddOnTaxes: '追加税を含める',
        IncludeAddOnServiceCharges: '追加サービス料を含める',
        IncludeCondiments: '調味料を含める',
        ExcludeInSubtotal: '小計に含めない',
        ExcludeIncludedTaxes: '含まれる税を除外',
        ExcludeIncludedServiceCharges: '含まれるサービス料を除外',
        PercentageOff: 'パーセントオフ',
        Quantity: '数量',
    },
    kr: {
        Basic: '기본 정보',
        SubtotalOptions: '소계 옵션',
        IncludeInSubtotal: '소계에 포함',
        IncludeItemDiscount: '항목 할인/서비스 요금 포함',
        IncludeAddOnTaxes: '추가 세금 포함',
        IncludeAddOnServiceCharges: '추가 서비스 요금 포함',
        IncludeCondiments: '조미료 포함',
        ExcludeInSubtotal: '소계에서 제외',
        ExcludeIncludedTaxes: '포함된 세금 제외',
        ExcludeIncludedServiceCharges: '포함된 서비스 요금 제외',
        PercentageOff: '퍼센트 할인',
        Quantity: '수량',
    },
}